import { gql } from '@/__generated__';

const UPDATE_DEVICE_COLLECTION_RELATIONS = gql(`#graphql
  mutation UpdateDeviceCollectionRelations($deviceId: String!, $inputs: [UpdateDeviceCollectionRelationInput!]!) {
    updateDeviceCollectionRelations(deviceId: $deviceId, inputs: $inputs) {
      updatedCollectionIds
    }
  }
`);

export default UPDATE_DEVICE_COLLECTION_RELATIONS;
